export default {
    methods: {
			handlePerc(value , input_name, number_perc) {
				this.percs[input_name] = parseInt(value);
				if (this.percs[input_name] < 1) this.percs[input_name] = 1;
				if (this.percs[input_name] > 100) this.percs[input_name] = 100;
				let next_perc =
					number_perc === this.model.urlsToShortNumber ? 1 : number_perc + 1;
				let percs_sum = Object.keys(this.percs)
					.map((v) => this.percs[v])
									.filter(n => Number(n))
					.reduce((a, b) => Number(a) + Number(b));
				if (percs_sum < 100) {
					this.percs["perc_" + next_perc] =
						this.percs["perc_" + next_perc] + (100 - percs_sum);
				}
				if (percs_sum > 100) {
					this.percs["perc_" + next_perc] =
						this.percs["perc_" + next_perc] - (percs_sum - 100);
				}
				this.handleValues();
			},
			handleValues() {
				let perc_keys = Object.keys(this.percs);
				let urls_keys = Object.keys(this.urls);
				let urlNumber = this.model.urlsToShortNumber;
				let hasurlempty = urls_keys.some(
					(value, index) => !this.urls[value] && index <= urlNumber - 1
				);
				let haspercsempty = perc_keys.some(
					(value, index) => !this.percs[value] && index <= urlNumber - 1
				);
	
				this.model.testeAbName = this.model.testeAbName.replace(/[^\w\s]/gi, '')
	
				if (!this.model.testeAbName) return (this.can_save = false);
				if (hasurlempty) return (this.can_save = false);
				if (haspercsempty) return (this.can_save = false);
				if (
					perc_keys &&
					perc_keys
						.map((v) => this.percs[v])
						.filter(n => Number(n))
						.reduce((a, b) => Number(a) + Number(b)) !== 100
				)
					return (this.can_save = false);
	
				return (this.can_save = true);
			},
			handleGenerate(e) {
				e.preventDefault();
				this.isurlactives = true;
				this.showCardCreate = false;
				this.can_save = false
				this.model.urlsToShortNumber = this.model.urlsNumber;
	
				Object.keys(this.percs).forEach((v) => {
					this.percs[v] = null;
				});
	
				Object.keys(this.urls).forEach((v, index) => {
					if((index+1) > this.model.urlsNumber) this.urls[v] = null;
				});
	
				let count = 0;
				while (count !== this.model.urlsToShortNumber) {
					this.percs["perc_" + (count + 1)] = parseInt(
						100 / Number(this.model.urlsToShortNumber)
					);
					count++;
				}
	
				if (this.percs["perc_1"] === 33) {
					this.percs["perc_1"] = 34;
				}
	
				this.handleValues();
			},
			handleNumber() {
				this.model.urlsNumber =
					this.model.urlsNumber > 5 ? 5 : this.model.urlsNumber;
				this.model.urlsNumber =
					this.model.urlsNumber < 1 ? 1 : this.model.urlsNumber;
	
				this.handleValues();
			},
			decreaseCounter(e) {
				e.preventDefault();
				if (this.model.urlsNumber > 1) {
					this.model.urlsNumber--;
				}
			},
			increaseCounter(e) {
				e.preventDefault();
				if (this.model.urlsNumber < 5) {
					this.model.urlsNumber++;
				}
			},
			copyLink(n) {
				this.$refs[n][0].value
				document.execCommand('copy')
				navigator.clipboard.writeText(this.$refs[n][0].value);
				this.toaster.visible = true,
				this.toaster.color = 'success',
				this.toaster.message = 'Url Copiada'
			},
    },
		watch: {
			'model.urlLong' () {
				this.model.urlLong === '' ? this.disabled = true : this.disabled = false 
			},
			'testeAB' () {
				this.model = {
					urlsToShortNumber: this.testeAB.urls.length,
					urlsNumber: this.testeAB.urls.length,
					testeAbName: this.testeAB.name,
				};
				this.testeAB.urls.forEach((url, index) => {
					this.percs["perc_" + (index + 1)] = url.percentage;
					this.urls["url_" + (index + 1)] = url.referenceUrl;
				});
			},
			'percs.perc_1' (value) {
				this.handlePerc(value, 'perc_1', 1)
			},
			'percs.perc_2' (value) {
				this.handlePerc(value, 'perc_2', 2)
			},
			'percs.perc_3' (value) {
				this.handlePerc(value, 'perc_3', 3)
			},
			'percs.perc_4' (value) {
				this.handlePerc(value, 'perc_4', 4)
			},
			'percs.perc_5' (value) {
				this.handlePerc(value, 'perc_5', 5)
			},
		}

}


// WEBPACK FOOTER //
// ./src/mixins/splitTest.js